import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import photos from './photos'
/**
* @see \App\Http\Controllers\Studio\GalleryController::index
* @see app/Http/Controllers/Studio/GalleryController.php:25
* @route '/studio/galerie'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/studio/galerie',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Studio\GalleryController::index
* @see app/Http/Controllers/Studio/GalleryController.php:25
* @route '/studio/galerie'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\GalleryController::index
* @see app/Http/Controllers/Studio/GalleryController.php:25
* @route '/studio/galerie'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::index
* @see app/Http/Controllers/Studio/GalleryController.php:25
* @route '/studio/galerie'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::index
* @see app/Http/Controllers/Studio/GalleryController.php:25
* @route '/studio/galerie'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::index
* @see app/Http/Controllers/Studio/GalleryController.php:25
* @route '/studio/galerie'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::index
* @see app/Http/Controllers/Studio/GalleryController.php:25
* @route '/studio/galerie'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Studio\GalleryController::create
* @see app/Http/Controllers/Studio/GalleryController.php:66
* @route '/studio/galerie/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/studio/galerie/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Studio\GalleryController::create
* @see app/Http/Controllers/Studio/GalleryController.php:66
* @route '/studio/galerie/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\GalleryController::create
* @see app/Http/Controllers/Studio/GalleryController.php:66
* @route '/studio/galerie/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::create
* @see app/Http/Controllers/Studio/GalleryController.php:66
* @route '/studio/galerie/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::create
* @see app/Http/Controllers/Studio/GalleryController.php:66
* @route '/studio/galerie/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::create
* @see app/Http/Controllers/Studio/GalleryController.php:66
* @route '/studio/galerie/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::create
* @see app/Http/Controllers/Studio/GalleryController.php:66
* @route '/studio/galerie/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Studio\GalleryController::store
* @see app/Http/Controllers/Studio/GalleryController.php:73
* @route '/studio/galerie/store'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/studio/galerie/store',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Studio\GalleryController::store
* @see app/Http/Controllers/Studio/GalleryController.php:73
* @route '/studio/galerie/store'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\GalleryController::store
* @see app/Http/Controllers/Studio/GalleryController.php:73
* @route '/studio/galerie/store'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::store
* @see app/Http/Controllers/Studio/GalleryController.php:73
* @route '/studio/galerie/store'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::store
* @see app/Http/Controllers/Studio/GalleryController.php:73
* @route '/studio/galerie/store'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Studio\GalleryController::edit
* @see app/Http/Controllers/Studio/GalleryController.php:85
* @route '/studio/galerie/{gallery}/edit'
*/
export const edit = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/studio/galerie/{gallery}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Studio\GalleryController::edit
* @see app/Http/Controllers/Studio/GalleryController.php:85
* @route '/studio/galerie/{gallery}/edit'
*/
edit.url = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { gallery: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { gallery: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
    }

    return edit.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\GalleryController::edit
* @see app/Http/Controllers/Studio/GalleryController.php:85
* @route '/studio/galerie/{gallery}/edit'
*/
edit.get = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::edit
* @see app/Http/Controllers/Studio/GalleryController.php:85
* @route '/studio/galerie/{gallery}/edit'
*/
edit.head = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::edit
* @see app/Http/Controllers/Studio/GalleryController.php:85
* @route '/studio/galerie/{gallery}/edit'
*/
const editForm = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::edit
* @see app/Http/Controllers/Studio/GalleryController.php:85
* @route '/studio/galerie/{gallery}/edit'
*/
editForm.get = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::edit
* @see app/Http/Controllers/Studio/GalleryController.php:85
* @route '/studio/galerie/{gallery}/edit'
*/
editForm.head = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Studio\GalleryController::update
* @see app/Http/Controllers/Studio/GalleryController.php:140
* @route '/studio/galerie/{gallery}/update'
*/
export const update = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/studio/galerie/{gallery}/update',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Studio\GalleryController::update
* @see app/Http/Controllers/Studio/GalleryController.php:140
* @route '/studio/galerie/{gallery}/update'
*/
update.url = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { gallery: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { gallery: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
    }

    return update.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\GalleryController::update
* @see app/Http/Controllers/Studio/GalleryController.php:140
* @route '/studio/galerie/{gallery}/update'
*/
update.patch = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::update
* @see app/Http/Controllers/Studio/GalleryController.php:140
* @route '/studio/galerie/{gallery}/update'
*/
const updateForm = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::update
* @see app/Http/Controllers/Studio/GalleryController.php:140
* @route '/studio/galerie/{gallery}/update'
*/
updateForm.patch = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Studio\GalleryController::destroy
* @see app/Http/Controllers/Studio/GalleryController.php:164
* @route '/studio/galerie/{gallery}/delete'
*/
export const destroy = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/studio/galerie/{gallery}/delete',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Studio\GalleryController::destroy
* @see app/Http/Controllers/Studio/GalleryController.php:164
* @route '/studio/galerie/{gallery}/delete'
*/
destroy.url = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { gallery: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { gallery: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
    }

    return destroy.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\GalleryController::destroy
* @see app/Http/Controllers/Studio/GalleryController.php:164
* @route '/studio/galerie/{gallery}/delete'
*/
destroy.delete = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::destroy
* @see app/Http/Controllers/Studio/GalleryController.php:164
* @route '/studio/galerie/{gallery}/delete'
*/
const destroyForm = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::destroy
* @see app/Http/Controllers/Studio/GalleryController.php:164
* @route '/studio/galerie/{gallery}/delete'
*/
destroyForm.delete = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Studio\GalleryController::publish
* @see app/Http/Controllers/Studio/GalleryController.php:190
* @route '/studio/galerie/{gallery}/publikovat'
*/
export const publish = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: publish.url(args, options),
    method: 'post',
})

publish.definition = {
    methods: ["post"],
    url: '/studio/galerie/{gallery}/publikovat',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Studio\GalleryController::publish
* @see app/Http/Controllers/Studio/GalleryController.php:190
* @route '/studio/galerie/{gallery}/publikovat'
*/
publish.url = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { gallery: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { gallery: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
    }

    return publish.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\GalleryController::publish
* @see app/Http/Controllers/Studio/GalleryController.php:190
* @route '/studio/galerie/{gallery}/publikovat'
*/
publish.post = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: publish.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::publish
* @see app/Http/Controllers/Studio/GalleryController.php:190
* @route '/studio/galerie/{gallery}/publikovat'
*/
const publishForm = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: publish.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::publish
* @see app/Http/Controllers/Studio/GalleryController.php:190
* @route '/studio/galerie/{gallery}/publikovat'
*/
publishForm.post = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: publish.url(args, options),
    method: 'post',
})

publish.form = publishForm

/**
* @see \App\Http\Controllers\Studio\GalleryController::unpublish
* @see app/Http/Controllers/Studio/GalleryController.php:218
* @route '/studio/galerie/{gallery}/publikovat'
*/
export const unpublish = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: unpublish.url(args, options),
    method: 'delete',
})

unpublish.definition = {
    methods: ["delete"],
    url: '/studio/galerie/{gallery}/publikovat',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Studio\GalleryController::unpublish
* @see app/Http/Controllers/Studio/GalleryController.php:218
* @route '/studio/galerie/{gallery}/publikovat'
*/
unpublish.url = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { gallery: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { gallery: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            gallery: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        gallery: typeof args.gallery === 'object'
        ? args.gallery.slug
        : args.gallery,
    }

    return unpublish.definition.url
            .replace('{gallery}', parsedArgs.gallery.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Studio\GalleryController::unpublish
* @see app/Http/Controllers/Studio/GalleryController.php:218
* @route '/studio/galerie/{gallery}/publikovat'
*/
unpublish.delete = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: unpublish.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::unpublish
* @see app/Http/Controllers/Studio/GalleryController.php:218
* @route '/studio/galerie/{gallery}/publikovat'
*/
const unpublishForm = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unpublish.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Studio\GalleryController::unpublish
* @see app/Http/Controllers/Studio/GalleryController.php:218
* @route '/studio/galerie/{gallery}/publikovat'
*/
unpublishForm.delete = (args: { gallery: string | { slug: string } } | [gallery: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unpublish.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

unpublish.form = unpublishForm

const galleries = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    publish: Object.assign(publish, publish),
    unpublish: Object.assign(unpublish, unpublish),
    photos: Object.assign(photos, photos),
}

export default galleries